import config from "../_config/config";
import { authHeader } from "../_helpers";
import axios from "axios";

axios.defaults.baseURL = config.apiUrl;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.put["Content-Type"] = "application/json";
axios.defaults.headers.put["X-Requested-With"] = "XMLHttpRequest";

export const brandingService = {
  getCompanyBranding,
  updateCompanyBranding,
  attachBannerResource,
  deleteBanner,
};

function getCompanyBranding() {
  var sett = { headers: authHeader() };
  return axios
    .get("companies/own/branding", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function updateCompanyBranding(data) {
  var sett = { headers: authHeader() };
  return axios
    .put("companies/own/branding", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function attachBannerResource(hashid) {
  var sett = { headers: authHeader() };
  return axios
    .post("companies/own/branding/banner", { resource: hashid }, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function deleteBanner() {
  var sett = { headers: authHeader() };
  return axios
    .delete("companies/own/branding/banner", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}
